import { useState } from 'react';
import { SimpleButton } from '../../../common';
import { markFormToSignURL } from '../digitalSign/misc';
import ApiaApi from '../../../../api/apiaApi/apiaApi';
import makeImperativeComponent from '../../../../classes/imperative/makeImperativeComponent';
import useImperativeComponentEvents from '../../../../classes/imperative/useImperativeComponentEvents';

const [, markFormToSign, MarkToSignButton] = makeImperativeComponent<
  {
    isDefaultMarkedToSign?: boolean;
    requiredSignableForm?: boolean;
    formId: string;
    frmParent: string;
  },
  {
    markToSign: boolean;
  }
>()({
  Component: ({
    isDefaultMarkedToSign,
    requiredSignableForm,
    formId,
    frmParent,
  }) => {
    const [isMarkedToSign, setIsMarkedToSign] = useState<boolean>(
      isDefaultMarkedToSign ?? false,
    );

    useImperativeComponentEvents<{
      markToSign: boolean;
    }>({ markToSign: setIsMarkedToSign });

    return (
      <SimpleButton
        className={isMarkedToSign ? 'toggled' : ''}
        {...window.getVariant('secondary')}
        disabled={requiredSignableForm}
        onClick={() => {
          void ApiaApi.post<{ success: boolean }>(
            markFormToSignURL({
              frmId: formId,
              frmParent,
              sign: !isMarkedToSign,
            }),
          ).then((res) => {
            if (res?.data && res.data.success) {
              setIsMarkedToSign(!isMarkedToSign);
            }
          });
        }}
      >
        {window.BTN_MARK_FRM_TO_SIGN}
      </SimpleButton>
    );
  },
});

export { markFormToSign };
export default MarkToSignButton;
